import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: 'op-exchange-rate',
    templateUrl: './exchange-rate.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExchangeRateComponent {
}